<app-menu></app-menu>
<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div class="pageTitle mb-1 mt-1">
      {{ "fsplaca.titleList" | translate }}
    </div>

    <div class="filterTableContainer">
      <app-filters
        #outTable
        [filterList]="filterListOutTable"
        [options]="optionsFiltersOutTable"
        [type]="'buzon'"
        [titleOutTable]="titleFilters"
        (showfilterButtons)="toggleFilterButtons($event)"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-filters
        #insideTable
        [filterList]="filterList"
        [options]="options"
        [ngClass]="{ filterHidden: !showTableFilter }"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-table
        #table
        [tableList]="tableList"
        [elementList]="placasList"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons]="showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
      ></app-table>
    </div>
  </div>
</div>
